export const variables = {
  pxToRem: (px: number, rootPx = 16) => `${px / rootPx}rem`,
  pxToPercent: (basePx: number, relativePx: number) => `${(relativePx / basePx) * 100}%`,
}
